import { render, staticRenderFns } from "./EditPostBox.vue?vue&type=template&id=7c3f5b66"
import script from "./EditPostBox.vue?vue&type=script&lang=js"
export * from "./EditPostBox.vue?vue&type=script&lang=js"
import style0 from "./EditPostBox.vue?vue&type=style&index=0&id=7c3f5b66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports